import { useContext, useEffect, useState } from "react";
import abramsImg from "../assets/images/Abrams.png";
import { Link, useLocation } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import * as powerbi from "powerbi-client";
import ReportCard from "../Reports/ReportCard";
import axiosInstance from "../utils/AxiosInstance";
import { FaPlus } from "react-icons/fa";
import { useMsal } from "@azure/msal-react";

const Sidebar = ({ isSidebarOpen }) => {
  const [showAddButton, SetShowButton] = useState(false);
  const [status, setStatus] = useState();
  const[fetchUrlInReport,setfetchUrlInReport]=useState([])
  const location = useLocation(); // Get the current route location
  const {
    roles,
    setRoles,
    bookmarks,
    loader,
    modal,
    setModal,
    activeTab,
    setActiveTab,

    setBookMarks,
    isEditMode,
    setEditMode,
    selectedReport,
    confirmationModal,
    isPowerBi,
    setPowerBi,
    setLoader,
    confirmationModalRls,
    item,
    setItem,
    setToast,
    setConfirmationModalRls,
    embedToken,
    setEmbedToken,
    setConfirmationModal,
    setSelectedReport,
    setSelectedReportId,
    selectedReportId,
    viewerReports,
    groupRollups,
    setGroupRollups,
    setViewerReports,selectapplication,setSelectapplication,reportUrls, setReportUrls,allApplication,setAllApplication
  } = useContext(AppContext);
  // Check if the current route is the user management route
  const isActiveUserManagement = [
    "/user-management",
    "/user-management/add-user",
  ].includes(location.pathname);
  const isActiveReports = location.pathname === "/reports";
  const isDataSecurity = location.pathname === "/data-security";
  const { instance } = useMsal();

  const account = instance.getActiveAccount();
  const fetchData = async (searchTerm) => {
    try {
      setLoader(true);

      const cleanSearchTerm = searchTerm?.trim();
      const response = await axiosInstance.get(
        `/bookmarks${cleanSearchTerm ? "?search=" + cleanSearchTerm : ""}`
      );
      if (response.status === 200) {
        setBookMarks(response.data);
      }

      setTimeout(() => {
        setLoader(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    }
  };
  useEffect(() => {
    // alert("DEBOUNCE")
    fetchData();
  }, []);




  useEffect(() => {
    if (location.pathname !== "/reports") {
      setSelectedReportId(null);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      (isActiveReports || isDataSecurity || isActiveUserManagement) &&
      bookmarks.length > 0
    ) {
      setPowerBi(false);
      SetShowButton(true);
    }
  }, [isActiveReports, bookmarks]);

  useEffect(() => {
    const email = account.username;

    

    if (
      !(
        roles?.role_name?.includes("Admin") &&
        !roles?.role_name?.includes("Editor")
      )
    ) {
      fetchReports(account.username);
    }

    
    
  }, [account.username]);
// const fetchStatus = async (email,reportId) => {
    

//       const body = { email,reportId};

//       try {
//         setLoader(true);

//         const response = await axiosInstance.post("/Status-By-email", body);
//         let status = response.data.status || [];

//         if (status.length > 0 && typeof status[0] === "string") {
//           status = status[0].split(",").map((item) => item.trim());
//         }
//        return status
//       } catch (err) {
//         console.error("API Error:", err);
//         setStatus([]);
//         setLoader(false);
//       }
//     };


  const fetchReports = async (email) => {
    try {
      const response = await axiosInstance.get(
        `/getReports?searchTerm=${email}`
      );
      if (response.status == 200) {
        setViewerReports(response?.data?.reports[0]?.report);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const check_rlsExistance = async (reportId,id) => {
    setLoader(true);
    try {
      const response = await axiosInstance.post("/check_rls", { reportId,id });

      return response?.data?.records?.length > 0;
    } catch (error) {
      console.error("Error fetching roles:", error);
      return false;
    } finally {
      setLoader(false);
    }
  };
  const handleDeleteReport = async (item, reportId) => {

    console.log("item22", item);
    

    const exists = await check_rlsExistance(reportId,item);

    if (!exists) {
      setConfirmationModal({
        id: item,
        show: true,
      });
    } else {
      setConfirmationModalRls({ id: item, reportId: reportId, show: true });
    }
  };
  // const handleReload = () => {
  //   console.log("item", item);
  //   handleReportClick(item);
  // };
  const fetchGroupRollups = async (email, report) => {
    const body = { email: email, report_id: report };
    try {
      setLoader(true);
      const response = await axiosInstance.post("/GL-By-email", body);
      let groupRollups = response?.data?.data[0] || [];


      return groupRollups; // Return the processed data
    } catch (err) {
      console.error("API Error:", err);
      return [];
    } finally {
      setLoader(false);
    }
  };

  const handleReportClick = async (report) => {
    setSelectedReportId(report?._id);
    setItem(report);
    setPowerBi(true);

  };
  
   const handleAppClick = (url) => {
    setItem();
    window.open(url, "_parent");
  };
const fetchUserApplications = async (email) => {
  try {
    const response = await axiosInstance.post("/get_reports_with_ids", { email });
    setfetchUrlInReport(response?.data?.data || []);
     setReportUrls(response?.data?.data || []);  
  } catch (error) {
    console.error("Error fetching applications:", error);
    setfetchUrlInReport([]); 
      setReportUrls([]);
  }
};
const fetchApplicationsByIds = async (env) => {
  try {
    const response = await axiosInstance.post("/get_applications_with_ids", { env });
    setAllApplication(response?.data?.data || []);  
  } catch (error) {
    console.error("Error fetching applications:", error);
    setAllApplication([]); 
  }
};

useEffect(() => {
 
  const environment = process.env.REACT_APP_ENVIRONMENT;
  
  if (environment) {
    fetchApplicationsByIds(environment);
  }

  if (account?.username) {
    fetchUserApplications(account.username);
  }
}, []);

  return (
    <div
      className={`h-full ${
        isSidebarOpen
          ? "w-[150px] md:w-[200px] lg:w-72 border-[2px] min-w-[100px] md:min-w-[160px]"
          : "w-0"
      } overflow-hidden`}
      style={{ height: "100vh" }}
    >
      {/* Sidebar content */}
      <div className="flex flex-col h-full">
        {/* Logo and Toggle */}
        <div className="flex items-center justify-center p-4">
          {isSidebarOpen && (
            <div className="flex items-center space-x-2">
              <img
                src={abramsImg}
                alt="Logo"
                className="object-contain w-full h-[60px]"
              />
            </div>
          )}
        </div>

        {/* Menu Items */}
        <nav className="mr-4">
          {[
            // If the role includes "Viewer", only show Reports tab
            ...(roles?.role_name?.includes("Viewer")
              ? [
                  {
                    path: "/reports",
                    label: "Reporting & Analytics",
                    active: isActiveReports,
                  },
                ]
              : [
                  roles?.role_name?.includes("Admin") && {
                    path: "/user-management",
                    label: "User Management",
                    active: isActiveUserManagement,
                  },
                  {
                    path: "/data-security",
                    label: " Access Management ",
                    active: isDataSecurity,
                  },
                  {
                    path: "/reports",
                    label: "Reporting & Analytics",
                    active: isActiveReports,
                  },
                ]),
          ]
            .filter(Boolean) 
            .map(({ path, label, active }) => (
              <Link to={path} key={label}>
                <button
                  className={`flex items-center p-3 mb-1 text-left rounded-lg py-2 mx-2 w-full transition-all duration-200
              ${
                active
                  ? "bg-red-200 text-[#E31c23] font-bold"
                  : "text-black-400 hover:bg-rose-100"
              }
            `}
                  onClick={(e) => {
                    if (label === "Reporting & Analytics") {
                      e.preventDefault(); // disable navigation for Reports
                      return;
                    }
                  }}
                  style={{ height: "50px" }}
                >
                  {isSidebarOpen && (
                    <div className="flex justify-between w-full items-center">
                      {/* Reports label */}
                      <h2
                        className={`${
                          active ? "font-bold" : "text-black-400 font-semibold"
                        } text-[10px] sm:text-[14px]`}
                      >
                        {label}
                      </h2>

                      {/* + button only for Reports & Admin/Editor */}
                      {label === "Reporting & Analytics" &&
                        (roles?.role_name?.includes("Admin") ||
                          roles?.role_name?.includes("Editor")) && (
                          <>
                            <button
                              className="flex items-center justify-center w-8 h-8 rounded-full bg-[#e31c23] text-white hover:bg-red-600 transition-colors duration-200 shadow-md"
                              onClick={(e) => {
                                e.stopPropagation();
                                setEditMode(false);
                                setSelectedReport(null)
                                setModal(true);
                              }}
                            >
                              <FaPlus size={14} />
                            </button>
                          </>
                        )}
                    </div>
                  )}
                </button>
                <div className="px-1 flex-1 overflow-y-auto overflow-x-hidden max-h-[calc(70vh-50px)]">
                  {(showAddButton && label === "Reporting & Analytics"
                    ? roles?.role_name?.includes("Viewer")
                      ? bookmarks.filter((item) =>
                          viewerReports?.some(
                            (report) => report._id === item._id
                          )
                        )
                      : bookmarks
                    : roles?.role_name?.includes("Viewer")
                    ? bookmarks

                        .filter((item) =>
                          viewerReports?.some(
                            (report) => report._id === item._id
                          )
                        )

                        .filter((item) => item.bookmark)
                    : bookmarks.filter((item) => item.bookmark)
                  )
                    .sort((a, b) => a.title.localeCompare(b.title))
                    .map((item, index) => {
                      const isReportActive = selectedReportId === item._id;
                      return (
                        <div className="ml-6 mt-2 space-y-2 ">
                          <ReportCard
                            className={
                              isReportActive
                                ? "bg-red-200 text-[#E31c23] font-bold"
                                : "text-black-400 hover:bg-rose-100"
                            }
                            key={item._id}
                            item={item}
                            roles={roles}
                            setEditMode={setEditMode}
                            setSelectedReport={setSelectedReport}
                            setModal={setModal}
                            handleDeleteReport={handleDeleteReport}
                            // updateBookmarkStatus={updateBookmarkStatus}

                            onClick={handleReportClick}
                            smallView
                          />
                        </div>
                      );
                    })}
                </div>
              </Link>
            ))}
             <div className="ml-9 mt-2">
                        {fetchUrlInReport
                          ?.sort((a, b) => a.NAME.localeCompare(b.NAME))
                          .map((app) => (
                            <div
                              key={app.ID}
                              className="text-black-400 hover:bg-rose-100 cursor-pointer p-3 rounded-lg
                                text-sm font-semibold  text-[12px] hover:scale-105 hover:z-10"
                              onClick={() => handleAppClick(app.URL)}
                            >
                              {app.NAME}
                            </div> 
                          ))}
                      </div> 
        </nav>
        <div className="text-gray-400 bottom-1 left-2 absolute md:text-[14px] text-[10px]">
          <span>Version</span> 1.4.3
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
